export default __webpack_public_path__ + "static/hero-driver-3811142093de7b3d35e40906782749ca.jpg";